export const ROUTE = {
  VERIFICATION: {
    MAIN: 'verification',
    BEFORE_BEGIN: '',
    SEND_OTP: 'send-otp',
    QUERY_PARAM: { CODE: 'code', NRIC: 'nric' },
  },
  APPLICATION: {
    MAIN: 'application',
    CALCULATOR: 'calculator',
    GETTING_STARTED: 'getting-started',
    REVIEW_LOAN: 'review-loan',
  },
  LEAD: {
    MAIN: 'lead',
    GETTING_STARTED: 'getting-started',
    CALCULATOR: 'calculator',
    SUBMISSION: 'submission',
    THANK_YOU: 'thank-you',
    QUERY_PARAM: { TOKEN: 'actionToken' },
  },
  LETTER_OF_OFFER: {
    MAIN: 'letter-of-offer',
    SIGN_SINGPASS: 'sign-singpass',
    SIGN_CONFIRM: 'sign-confirm',
    SIGN_MANUAL: 'sign-manual',
    CALLBACK: 'callback',
    QUERY_PARAM: { TOKEN: 'accessToken' },
  },
  E_SIGN: {
    MAIN: 'e-sign',
    QUERY_PARAM: { TOKEN: 'accessToken' },
  },
  ERROR: {
    MAIN: 'error',
    BAD_REQUEST: '400',
    FORBIDDEN: '403',
    NOT_FOUND: '404',
    NOT_ALLOWED: '405',
    NOT_ACCEPTABLE: '406',
    OFFER_EXPIRED: 'offer-expired',
  },
  SUCCESS: {
    MAIN: 'success',
    APPROVED: 'approved',
    PROCESSED: 'processed',
    SIGN_OFF: 'sign-off',
    UNDER_REVIEW: 'under-review',
    SYSTEM_MAINTENANCE: 'system-maintenance',
    PARAM: { TYPE: 'type' },
  },
} as const;
